import { KeyboardEvent, useEffect, useRef, useState } from "react";

// ---- 인라인 추가 폼 ----

interface AddItemFormProps {
  fields: { key: string; placeholder: string; type?: string }[];
  onAdd: (values: Record<string, string>) => void;
  onCancel: () => void;
}

const AddItemForm = ({ fields, onAdd, onCancel }: AddItemFormProps) => {
  const [values, setValues] = useState<Record<string, string>>({});
  const firstRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    firstRef.current?.focus();
  }, []);

  const handleKey = (e: KeyboardEvent) => {
    if (e.key === "Enter") onAdd(values);
    if (e.key === "Escape") onCancel();
  };

  return (
    <div className="flex flex-col gap-1 border-b border-gray-100 bg-gray-50 p-2">
      {fields.map((f, i) => (
        <input
          key={f.key}
          ref={i === 0 ? firstRef : undefined}
          type={f.type ?? "text"}
          className="rounded-lg border border-gray-300 px-2 py-1 text-small outline-none focus:border-primary focus:ring-1 focus:ring-primary/20"
          placeholder={f.placeholder}
          value={values[f.key] ?? ""}
          onChange={e =>
            setValues(prev => ({ ...prev, [f.key]: e.target.value }))
          }
          onKeyDown={handleKey}
        />
      ))}
      <div className="flex gap-1">
        <button
          className="flex-1 rounded-lg bg-primary px-2 py-1 text-small text-white transition-colors hover:bg-primary/90"
          onClick={() => onAdd(values)}
        >
          추가
        </button>
        <button
          className="flex-1 rounded-lg border border-gray-200 px-2 py-1 text-small text-gray-dark transition-colors hover:bg-gray-50"
          onClick={onCancel}
        >
          취소
        </button>
      </div>
    </div>
  );
};

export default AddItemForm;
